'use client';

export { RouteErrorFallback as default } from '../components/ErrorFallback';
